import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AwsCreatePayload, AwsData, AwsSetPayload, UserInfo } from 'mbs-ui-shared@models/login';

@Injectable({
  providedIn: 'root'
})
export class AwsLoginService {
  private http = inject(HttpClient);
  public createAWSUser(payload: AwsCreatePayload) {
    return this.http.post<AwsData>('api/aws-marketplace/create', payload);
  }

  public setAWSUser(payload: AwsSetPayload) {
    return this.http.post('api/aws-marketplace/set', payload);
  }

  public getAwsUser() {
    return this.http.get<UserInfo>('api/aws-marketplace/info', {
      headers: new HttpHeaders({ MANUAL_SESSION_ERROR_HANDLED: 'MANUAL_SESSION_ERROR_HANDLED' })
    });
  }
}
